export default __webpack_public_path__ + "static/media/Gezelligheid met hapjes en partners.d2b6a2bf.jpg";